module.exports = __webpack_public_path__ + "img/bulb.509ccc16.svg";